var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud',{attrs:{"config":_vm.config}})
}
var staticRenderFns = []

export { render, staticRenderFns }